import AlertRegular from 'mini-fluent-svg-icons/lib/icons/AlertRegular';
import ArrowCircleLeftRegular from 'mini-fluent-svg-icons/lib/icons/ArrowCircleLeftRegular';
import ArrowCircleRightRegular from 'mini-fluent-svg-icons/lib/icons/ArrowCircleRightRegular';
import ArrowDownRegular from 'mini-fluent-svg-icons/lib/icons/ArrowDownRegular';
import ArrowForwardRegular from 'mini-fluent-svg-icons/lib/icons/ArrowForwardRegular';
import ArrowReplyRegular from 'mini-fluent-svg-icons/lib/icons/ArrowReplyRegular';
import AttachRegular from 'mini-fluent-svg-icons/lib/icons/AttachRegular';
import CalendarCancelRegular from 'mini-fluent-svg-icons/lib/icons/CalendarCancelRegular';
import CalendarCheckmarkRegular from 'mini-fluent-svg-icons/lib/icons/CalendarCheckmarkRegular';
import CalendarEmptyRegular from 'mini-fluent-svg-icons/lib/icons/CalendarEmptyRegular';
import CalendarQuestionMarkRegular from 'mini-fluent-svg-icons/lib/icons/CalendarQuestionMarkRegular';
import CheckboxCheckedSyncRegular from 'mini-fluent-svg-icons/lib/icons/CheckboxCheckedSyncRegular';
import CheckmarkCircleRegular from 'mini-fluent-svg-icons/lib/icons/CheckmarkCircleRegular';
import CheckmarkSquareRegular from 'mini-fluent-svg-icons/lib/icons/CheckmarkSquareRegular';
import ContactCardRegular from 'mini-fluent-svg-icons/lib/icons/ContactCardRegular';
import DoorArrowLeftRegular from 'mini-fluent-svg-icons/lib/icons/DoorArrowLeftRegular';
import FaxRegular from 'mini-fluent-svg-icons/lib/icons/FaxRegular';
import ImportantRegular from 'mini-fluent-svg-icons/lib/icons/ImportantRegular';
import MentionRegular from 'mini-fluent-svg-icons/lib/icons/MentionRegular';
import NotebookRegular from 'mini-fluent-svg-icons/lib/icons/NotebookRegular';
import NotePinRegular from 'mini-fluent-svg-icons/lib/icons/NotePinRegular';
import NoteRegular from 'mini-fluent-svg-icons/lib/icons/NoteRegular';
import SubtractCircleFilled from 'mini-fluent-svg-icons/lib/icons/SubtractCircleFilled';
import ThumbLikeRegular from 'mini-fluent-svg-icons/lib/icons/ThumbLikeRegular';
import VoicemailArrowBackRegular from 'mini-fluent-svg-icons/lib/icons/VoicemailArrowBackRegular';
import VoicemailArrowForwardRegular from 'mini-fluent-svg-icons/lib/icons/VoicemailArrowForwardRegular';
import VoicemailRegular from 'mini-fluent-svg-icons/lib/icons/VoicemailRegular';
import { PropertyIcons } from '../schema/PropertyIcons';
/**
 * Gets the style of the property icon passed as input
 * Do not include owa-sprites for now since it's currently targeted for consumers.
 * var spriteStyles = require('owa-sprite/dist/styles/mail_sprite.css');
 * @param propertyIcon
 */

export function getPropertyIconName(propertyIcon: PropertyIcons): string {
    switch (propertyIcon) {
        case PropertyIcons.GlobalMentionedMe:
            return MentionRegular;
        case PropertyIcons.Attachment:
            return AttachRegular;
        case PropertyIcons.ImportanceLow:
            return ArrowDownRegular;
        case PropertyIcons.ImportanceHigh:
            return ImportantRegular;
        case PropertyIcons.Like:
            return ThumbLikeRegular;
        case PropertyIcons.MailListViewReplied:
            return ArrowReplyRegular;
        case PropertyIcons.MailListViewForwarded:
            return ArrowForwardRegular;
        case PropertyIcons.MailListViewIRM:
            return SubtractCircleFilled;
        case PropertyIcons.MailListViewIRMReplied:
            //return spriteStyles["mail-icon-irm_replied"];
            return SubtractCircleFilled;
        case PropertyIcons.MailListViewIRMForwarded:
            //return spriteStyles["mail-icon-irm_forwarded"];
            return SubtractCircleFilled;
        case PropertyIcons.MailListViewVoiceMailItem:
            return VoicemailRegular;
        case PropertyIcons.MailListViewVoiceMailReplied:
            return VoicemailArrowBackRegular;
        case PropertyIcons.MailListViewVoiceMailForwarded:
            return VoicemailArrowForwardRegular;
        case PropertyIcons.MailListViewVoiceMailIRM:
            //return spriteStyles["mail-icon-voicemail_irm"];
            return SubtractCircleFilled;
        case PropertyIcons.MailListViewFaxItem:
            return FaxRegular;
        case PropertyIcons.MailListViewAppointmentItem:
            return CalendarEmptyRegular;
        case PropertyIcons.MailListViewAppointmentAccepted:
            //return spriteStyles["mail-icon-event_accepted"];
            return CalendarCheckmarkRegular;
        case PropertyIcons.MailListViewAppointmentDeclined:
            //return spriteStyles["mail-icon-event_declined"];
            return CalendarCancelRegular;
        case PropertyIcons.MailListViewAppointmentTentative:
            //return spriteStyles["mail-icon-event_tentative"];
            return CalendarQuestionMarkRegular;
        case PropertyIcons.MailListViewAppointmentCanceled:
            return CalendarCancelRegular;
        case PropertyIcons.MailListViewContactItem:
            return ContactCardRegular;
        case PropertyIcons.MailListViewTaskItem:
            return CheckmarkSquareRegular;
        case PropertyIcons.MailListViewTaskReocurItem:
            return CheckboxCheckedSyncRegular;
        case PropertyIcons.MailListViewJournalItem:
            return NotebookRegular;
        case PropertyIcons.MailListViewPostItem:
            return NotePinRegular;
        case PropertyIcons.MailListViewNoteItem:
            return NoteRegular;
        case PropertyIcons.MailListViewDelivery:
            // Bug 1752 - culture specific
            return ArrowCircleRightRegular;
        case PropertyIcons.MailListViewNonDelivery:
            // Bug 1752 - culture specific
            return ArrowCircleLeftRegular;
        case PropertyIcons.MailListViewApprovalRequest:
            // add sprite response_request.png
            return ArrowCircleLeftRegular;
        case PropertyIcons.MailListViewResponseApprove:
            // add sprite response_approve.png
            return ArrowCircleLeftRegular;
        case PropertyIcons.MailListViewResponseReject:
            // add sprite response_reject.png
            return ArrowCircleLeftRegular;
        case PropertyIcons.MailListViewOutOfOffice:
            // Bug 1752 - culture specific
            return DoorArrowLeftRegular;
        case PropertyIcons.MailListViewReadReport:
            return CheckmarkCircleRegular;
        case PropertyIcons.MailListViewReminderMessage:
            return AlertRegular;
        default:
            throw new Error('No CSS class icon for the given property icon');
    }
}
